import mixins from './mixins';

const theme = {
  bp: {
    mobileL: `min-width: 481px`,
    tabletS: `min-width: 601px`,
    tabletL: `min-width: 769px`,
    desktopS: `min-width: 1081px`,
  },

  mixins,
};

export default theme;
